import {
    useCallback, useEffect, useState,
} from 'react'
import {
    OptionType,
} from '../ArrayFilterAutocompleteInput'

const useDropdownWithLoadingWhenMounting = ({
    data,
}: Readonly<{ data: OptionType[] }>) => {
    const [
        isOpen,
        setIsOpen,
    ] = useState(false)

    const [
        mountedOptions,
        setMountedOptions,
    ] = useState<OptionType[]>([])

    const [
        isLoadingOptions,
        setIsLoadingOptions,
    ] = useState(false)

    /* Mount options when dropdown is opened.
    This is to show loading spinner when there are many options to render what takes time */
    useEffect(() => {
        if (isOpen && data.length > 0 && mountedOptions.length === 0) {
            setMountedOptions(data)
        }
    }, [
        data,
        mountedOptions.length,
        isOpen,
    ])

    // stop loading when options are mounted
    useEffect(() => {
        if (mountedOptions.length > 0 && isLoadingOptions) {
            setIsLoadingOptions(false)
        }
    }, [
        isLoadingOptions,
        mountedOptions.length,
    ])

    const onOpen = useCallback(() => {
        setIsOpen(true)
        if (data.length > 0) setIsLoadingOptions(true)
    }, [data.length])

    const onClose = useCallback(() => {
        setIsOpen(false)
        setMountedOptions([])
        setIsLoadingOptions(false)
    }, [])

    return {
        isOpen,
        onOpen,
        onClose,
        mountedOptions,
        isLoadingOptions,
    }
}

export default useDropdownWithLoadingWhenMounting
